export default __webpack_public_path__ + "static/media/pingoo-1.9c3cca7d.mp4";